import { observer } from 'mobx-react';
import { restaurantPropTypes, selectedLocationPropTypes } from '@nandosaus/prop-types';
import PropTypes from 'prop-types';
import React from 'react';

import { useFeature } from '@hooks/use-feature';
import { Box, Flex } from '../grid';
import { P } from '../typography/new';
import { RestaurantStatus } from '../restaurant-status';

const RestaurantDetails = ({ coordinates, onRestaurantClick, restaurant, type, linkText, showRestaurantStatus }) => {
  const { address, formattedDistanceToRestaurant, name } = restaurant;
  const formattedStatusMessage = restaurant.getFormattedStatusMessage();
  const comingSoonRestaurants = useFeature('coming-soon-restaurant-whitelist');
  const comingSoon = comingSoonRestaurants?.restaurantIds?.includes(parseInt(restaurant.id, 10)) || false;

  return (
    <>
      <Flex gap="8px">
        <Flex flexDirection="column">
          <P as="span" display="block" variant="standard-semi-bold">
            {name}
          </P>
          <P as="span" display="block" variant="extra-small" mt="4px">
            {address.address1}, {address.suburb} {address.state}
          </P>
          {formattedStatusMessage && !comingSoon && (
            <>
              {type === 'list' &&
                (showRestaurantStatus ? (
                  <RestaurantStatus showClosestRestaurant={false} restaurant={restaurant} mt="12px" displayAsList />
                ) : (
                  <P
                    as="span"
                    display="block"
                    mt="12px"
                    variant="extra-small-semi-bold"
                    color={restaurant.isOpen && restaurant.orderingEnabled ? 'goGreen' : undefined}
                  >
                    {formattedStatusMessage.subtitle}
                  </P>
                ))}
              {type !== 'list' && (
                <Box display="flex" flexDirection="column">
                  {showRestaurantStatus ? (
                    <RestaurantStatus showClosestRestaurant={false} restaurant={restaurant} mt="0.5rem" displayAsList />
                  ) : (
                    <P
                      as="span"
                      pt="8px"
                      display="block"
                      variant="extra-small-semi-bold"
                      color={restaurant.isOpen && restaurant.orderingEnabled ? 'goGreen' : undefined}
                    >
                      {formattedStatusMessage.subtitle}
                    </P>
                  )}
                  {restaurant.isOpen && restaurant.orderingEnabled && linkText && (
                    <P
                      as="button"
                      mt="8px"
                      width="fit-content"
                      textDecoration="underline"
                      variant="extra-small"
                      color="black"
                      onClick={() => onRestaurantClick(restaurant)}
                    >
                      {linkText}
                    </P>
                  )}
                </Box>
              )}
            </>
          )}
          {comingSoon && (
            <P variant="extra-small-semi-bold" mt="12px">
              New Restaurrant - Grilling Soon!
            </P>
          )}
        </Flex>
        {type !== 'list' && !showRestaurantStatus && coordinates && (
          <P as="span" display="block" variant="extra-small" color="grey-70">
            {formattedDistanceToRestaurant(coordinates)}
          </P>
        )}
      </Flex>
    </>
  );
};

RestaurantDetails.propTypes = {
  coordinates: selectedLocationPropTypes,
  linkText: PropTypes.string,
  onRestaurantClick: PropTypes.func.isRequired,
  restaurant: restaurantPropTypes.isRequired,
  type: PropTypes.string,
  showRestaurantStatus: PropTypes.bool,
};

RestaurantDetails.defaultProps = {
  coordinates: undefined,
  linkText: undefined,
  type: 'list',
  showRestaurantStatus: false,
};

const ComposedRestaurantDetails = observer(RestaurantDetails);
export { ComposedRestaurantDetails as RestaurantDetails };
